import { render, staticRenderFns } from "./custom_report_bottom.vue?vue&type=template&id=53a74833&scoped=true"
import script from "./custom_report_bottom.vue?vue&type=script&lang=js"
export * from "./custom_report_bottom.vue?vue&type=script&lang=js"
import style0 from "./custom_report_bottom.vue?vue&type=style&index=0&id=53a74833&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a74833",
  null
  
)

export default component.exports